import './editEmployee.component.scss';
import { Modal } from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import lang from '../../../../assets/i18n/en.json';
import React, { useState, useEffect } from 'react';
import Form from 'react-bootstrap/Form';
import {
  emailValidation,
  nameValidation,
  validateNumber,
} from '../../../../utils/Utils';
import { BasicPopup } from '../../../Common/basicPopup/BasicPopup';
import { toast } from 'react-toastify';
import { toastResponse } from '../../../../helper components/Toast/Toast';
import { useMutation } from '@apollo/client';
import { ConfirmationPopup } from '../../../Common/confirmationPopup/ConfirmationPopup';
import { UpdateEmployee } from '../../../../Mutations/MutationsUpdated';

export const EditEmployee = (props) => {
  /**
   * DECLARING STATES AND USEEFFECT
   */
  let PAGE = lang.PAGE;
  const ERROR = lang.ERROR;
  const [userData, setUserData] = useState({
    empId: '',
    firstName: '',
    lastName: '',
    emailId: '',
    mobileno: '',
    status: ''
  });

  const [showBasicPopup, setShowBasicPopup] = useState(false);
  const [showConfirm, setConfirm] = useState(false);
  // Reset the form data and errors when the modal is closed

  const [errors, setError] = useState({});

  useEffect(() => {
    setError({
      empId: false,
      empIdError: '',
      firstName: false,
      firstNameError: '',
      lastName: false,
      lastNameError: '',
      email: false,
      emailError: '',
      mobileno: false,
      mobilenoError: '',
    });

    setUserData({
          empId: props?.selectedRow ? props?.selectedRow.employeeId : '',
          firstName: props?.selectedRow ? props?.selectedRow.firstName : '',
          lastName: props?.selectedRow ? props?.selectedRow.lastName : '',
          emailId: props?.selectedRow ? props?.selectedRow.email : '',
          mobileno: props?.selectedRow ? props?.selectedRow.phoneNumber : '',
          status: props?.selectedRow ? props?.selectedRow.status : '',
      });

    // if (props?.selectedRow.name && typeof props.selectedRow.name === 'string') {
    //   const [firstName, lastName] = props.selectedRow.name.split(' ');

    //   setUserData({
    //     empId: props?.selectedRow ? props?.selectedRow.employeeId : '',
    //     firstName: firstName ? firstName : '',
    //     lastName: lastName ? lastName : '',
    //     emailId: props?.selectedRow.email ? props?.selectedRow.email : '',
    //     mobileno: props?.selectedRow.mobileno
    //       ? props?.selectedRow.mobileno
    //       : '',
    //   });
    // }
  }, [props?.selectedRow]);

  //Assign mutaions to variable
  const [updateEmployee, { loading }] = useMutation(
    UpdateEmployee,
    {
      onCompleted: (data) => {
        props.onEditHide();
        setShowBasicPopup(true);
      },

      onError: ({ graphQLErrors }) => {
        if(graphQLErrors) {
        toast.error(toastResponse('error', graphQLErrors[0].message));
        }else {
          toast.error(
            toastResponse('error', ERROR.CUSTOM.CODE.ERROR_API_RESPONSE),
          );
        }
      },
    },
  );

  //Assign mutaions to variable
  const [updateEnterpriseEmployeeUserStatus, { UserStatusloading }] = useMutation(
    UpdateEmployee,
    {
      onCompleted: (data) => {
        setConfirm(false);
        props.onEditHide();
        props.refetch();
      },

      onError: ({ graphQLErrors }) => {
        if(graphQLErrors) {
        toast.error(toastResponse('error', graphQLErrors[0].message));
        }else {
          toast.error(
            toastResponse('error', ERROR.CUSTOM.CODE.ERROR_API_RESPONSE),
          );
        }
      },
    },
  );

  const onMarkInactive = () => {
    try {
      const input = 
        {
          "status": props?.selectedRow.status === 'ACTIVE' ? 'INACTIVE' : 'ACTIVE'
        }
      

      updateEnterpriseEmployeeUserStatus({
        variables: {
          updateEmployeeId: props.selectedRow.id,
          input: input
        },
      });
    } catch (error) {
      toast.error(toastResponse('error', error));
    }
  };

  const onEditEmpDetail = () => {
    try {
      updateEmployee({
        variables: {
          updateEmployeeId: props.selectedRow.id,
          input: {
            firstName: userData.firstName,
            lastName: userData.lastName,
            //missing in update mutation
            // phone: userData.mobileno,
            email: userData.emailId
          } 
        },
      });
    } catch (error) {
      toast.error(toastResponse('error', error));
    }
  };

  return (
    <>
      <Modal
        show={props.showEdit}
        onHide={() => {
          props.onEditHide();
        }}
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header
          className="modal-header px-8 pt-8 pb-4"
          closeButton
          style={{
            borderBottom: '#fff',
            margin: '0%',
            alignItems: 'flex-start',
          }}
        >
          <Modal.Title>
            <div className="fw-bolder"> Employee Details</div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body
          className="px-8 py-0 modal-body"
          style={{ borderBottom: '#fff', margin: '0%' }}
        >
          <form className="form w-100 w-lg-450  h-100" autoComplete="off">
            {/*  <!--begin::Form group--> */}
            <div className="fv-row mb-4">
              <div className="col-md-12 pe-md-2 col-12 marginBottomRegister">
                <Form.Label>Employee ID</Form.Label>

                <Form.Control
                  type="text"
                  name="empId"
                  className="form-control form-control-lg form-control-solid fs-6"
                  placeholder={PAGE.AUTH.SIGNUP.FIRSTNAME.PLACEHOLDER}
                  value={userData.empId}
                  autoComplete="new-password"
                  tabIndex="1"
                  autoFocus
                  onChange={(e) => {
                    // {
                      setUserData((userData) => ({
                        ...userData,
                        empId: e.target.value,
                      }));
                    // }
                  }}
                  readOnly
                  isInvalid={errors.empId}
                />
                <Form.Control.Feedback type="invalid" style={{ color: 'red' }}>
                  {errors.empIdError}
                </Form.Control.Feedback>
              </div>
            </div>

            {/*  <!--begin::Form group--> */}
            <div className="fv-row mb-4">
              <div className="col-md-12 pe-md-2 col-12 marginBottomRegister">
                <Form.Label>{PAGE.AUTH.SIGNUP.FIRSTNAME.LABEL}</Form.Label>

                <Form.Control
                  type="text"
                  name="firstName"
                  className="form-control form-control-lg form-control-solid fs-6"
                  placeholder={PAGE.AUTH.SIGNUP.FIRSTNAME.PLACEHOLDER}
                  value={userData.firstName}
                  autoComplete="new-password"
                  tabIndex="1"
                  autoFocus
                  onChange={(e) => {
                    setUserData((userData) => ({
                      ...userData,
                      firstName: e.target.value,
                    }));
                    nameValidation(e.target.name, e.target.value, setError);
                  }}
                  isInvalid={errors.firstName}
                />
                <Form.Control.Feedback type="invalid" style={{ color: 'red' }}>
                  {errors.firstNameError}
                </Form.Control.Feedback>
              </div>
            </div>
            {/*   <!--end::Form group--> */}

            <div className="fv-row mb-4">
              <div className="col-md-12 col-12 ">
                <Form.Label>{PAGE.AUTH.SIGNUP.LASTNAME.LABEL}</Form.Label>
                <Form.Control
                  type="text"
                  name="lastName"
                  className="form-control form-control-lg form-control-solid fs-6"
                  tabIndex="2"
                  placeholder={PAGE.AUTH.SIGNUP.LASTNAME.PLACEHOLDER}
                  value={userData.lastName}
                  onChange={(e) => {
                    setUserData((userData) => ({
                      ...userData,
                      lastName: e.target.value,
                    }));
                    nameValidation(e.target.name, e.target.value, setError);
                  }}
                  isInvalid={errors.lastName}
                />
                <Form.Control.Feedback type="invalid" style={{ color: 'red' }}>
                  {errors.lastNameError}
                </Form.Control.Feedback>
              </div>
            </div>
            {/*
        <!--end::Form group--> */}
            {/* 
                       <!--begin::Form group--> */}
            <div className="fv-row mb-4">
              <Form.Label>{PAGE.AUTH.SIGNUP.EMAIL.LABEL}</Form.Label>
              <Form.Control
                type="email"
                name="emailId"
                value={userData.emailId}
                className="form-control form-control-lg form-control-solid fs-6"
                onChange={(e) => {
                  setUserData((userData) => ({
                    ...userData,
                    emailId: e.target.value,
                  }));
                  emailValidation(e.target.value, errors, setError);
                }}
                placeholder={PAGE.AUTH.SIGNUP.EMAIL.PLACEHOLDER}
                isInvalid={errors.email}
              />
              <Form.Control.Feedback type="invalid" style={{ color: 'red' }}>
                {errors.emailError}
              </Form.Control.Feedback>
            </div>
            {/*
                         <!--end::Form group--> */}

            {/* 
                       <!--begin::Form group--> */}
            <div className="fv-row mb-4">
              <Form.Label>Phone number</Form.Label>

              <Form.Control
                type="text"
                id="mobileno"
                name="mobileno"
                maxLength={10}
                value={userData.mobileno}
                className="form-control form-control-lg form-control-solid fs-6"
                placeholder={PAGE.AUTH.SIGNIN.USERNAME.PLACEHOLDER}
                onChange={(e) => {
                  setUserData((userData) => ({
                    ...userData,
                    mobileno: e.target.value,
                  }));
                  validateNumber(e.target.value, setError);
                }}
                tabIndex="4"
                autoFocus
                autoComplete=""
                required={errors.mobileno}
              />
              <Form.Control.Feedback
                type="required"
                style={{
                  color: 'red',
                  fontSize: '0.875em',
                  marginTop: '0.25rem',
                }}
              >
                {errors.mobilenoError}
              </Form.Control.Feedback>
            </div>
            {/*
                         <!--end::Form group--> */}
          </form>
        </Modal.Body>
        <Modal.Footer
          className="pt-0 px-8 pb-8 modal-footer"
          style={{ borderTop: '#fff', margin: '0%' }}
        >
          <Button
            className="theme me-3"
            onClick={() => setConfirm(true)}
            disabled={
              !(
                userData.empId &&
                userData.firstName &&
                userData.emailId &&
                userData.mobileno &&
                userData.lastName &&
                !errors.empId &&
                !errors.firstName &&
                !errors.lastName &&
                !errors.mobileno &&
                !errors.email
              )
            }
          >
            Mark as {' '}
            {props?.selectedRow.status === 'ACTIVE' ? 'Inactive' : 'Active'}
            {UserStatusloading && (
              <i
                className="spinner-grow spinner-grow-sm ms-3"
                role="status"
              />
            )}
          </Button>
          <Button
            className="theme m-0"
            onClick={onEditEmpDetail}
            disabled={
              !(
                userData.empId &&
                userData.firstName &&
                userData.emailId &&
                userData.mobileno &&
                userData.lastName &&
                !errors.empId &&
                !errors.firstName &&
                !errors.lastName &&
                !errors.mobileno &&
                !errors.email
              )
            }
          >
            Save Edits {loading && (
              <i
                className="spinner-grow spinner-grow-sm ms-3"
                role="status"
              />
            )}
          </Button>
        </Modal.Footer>
      </Modal>

      <ConfirmationPopup
        showConfirm={showConfirm}
        onConfirmHide={() => setConfirm(false)}
        headerText={
           `Employee ${props?.selectedRow.status === 'ACTIVE' ? 'Inactive' : 'Active'} Confirmation`
        }
        status={props?.selectedRow.status}
        modalBody={
           `Are you certain about marking these employee as ${props?.selectedRow.status === 'ACTIVE' ? "'inactive'" : "'active'"} Once they are marked as inactive, they will no longer have access to the app.`
        }
        otherBtnText={
          `Mark as  ${props?.selectedRow.status === 'ACTIVE' ? 'Inactive' : 'Active'}`
        }
        toggle={''}
        activeToggle={''}
        type={''}
        onConfirmStatus={() => onMarkInactive()}
      />

      <BasicPopup
        show={showBasicPopup}
        onHide={() => setShowBasicPopup(false)}
        popupTitle="Employee Details Edits Saved Successfully"
        popupSubTitle={'Employee Details Edits Saved successfully'}
        otherButtonText={''}
        onConfirmStatus={() => props.refetch()}
      />
    </>
  );
};
